import React, { type ComponentPropsWithoutRef, forwardRef } from 'react';

import type { IconComponent } from '../Icon/createIcon';
import { Text } from '../Text';

import { Styled } from './styles';

type DropdownItemProps = ComponentPropsWithoutRef<'div'> & {
  disabled?: boolean;
  icon?: IconComponent;
};
export const DropdownItem = forwardRef<HTMLDivElement, DropdownItemProps>(
  ({ icon: IconEl, children, role = 'button', tabIndex = 0, ...props }, ref) => (
    <Styled.Item {...props} space="s" ref={ref} tabIndex={tabIndex} role={role}>
      {IconEl && <IconEl />}
      <Text variant="caption">{children}</Text>
    </Styled.Item>
  ),
);
DropdownItem.displayName = 'DropdownItem';
